import { useContext, memo } from 'react';

import { useLanguage } from 'assets/languages';
import { GUIDELINE_RULE_DTO_ENUMS } from 'api/repositories/guidelineRules/guidelineRules.constants';
import CampaignFormFieldGroup from '../../../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import ProhibitionsField from '../../../formFields/prohibitionsField/prohibitionsField';
import ReelsRequestsField from './components/reelsRequestsField/reelsRequestsField';
import ReelsReferenceFields from '../../../../../formFields/reelsReferenceFields/reelsReferenceFields';
import GuideImageField from '../../../../../formFields/guideImageField/guideImageField';
import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';

const VideoGuidelineFieldGroup = () => {
  const language = useLanguage();
  const languageTexts = { ...language.pages.campaigns };
  const { brand } = useContext(CampaignFormContext);

  return (
    <CampaignFormFieldGroup label={languageTexts.create_reels_form_guideline}>
      {/* 영상 가이드라인 */}
      <ReelsRequestsField />

      {/* 참고 릴스 URL */}
      <ReelsReferenceFields />

      {/* 금지사항 */}
      <ProhibitionsField
        prohibitionsOptionNames={[
          GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_OPTIONS.OTHER_PEOPLE,
          GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_OPTIONS.MIRROR_SELFIE,
          GUIDELINE_RULE_DTO_ENUMS.PROHIBITIONS_OPTIONS.MASK,
        ]}
      />

      <GuideImageField
        label={`${brand.isWholesale ? 3 : 4}. ${
          languageTexts.create_reels_form_image_guideline
        }`}
        description={languageTexts.create_reels_form_image_guideline_fashion}
        uploadButtonText={languageTexts.create_reels_form_image_upload}
      />
    </CampaignFormFieldGroup>
  );
};

export default memo(VideoGuidelineFieldGroup);
